import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { type HighlightedName } from '@shared/utils/highlight';

/** A search result's name with the typed text marked, the same way in every search. */
@Component({
  selector: 'app-highlighted-text',
  // Each part is wrapped so the newlines between them are whitespace-only text nodes, which Angular
  // strips. Interpolated as bare siblings, they would leave a stray space either side of the match.
  template: `
    <span>{{ parts().before }}</span>
    @if (parts().match) {
      <mark class="highlighted-text__match">{{ parts().match }}</mark>
    }
    <span>{{ parts().after }}</span>
  `,
  styleUrls: ['./highlighted-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HighlightedTextComponent {
  readonly parts = input.required<HighlightedName>();
}
